import BaseAPI from './base.api.service'

const resource = 'expensereports';
export default {
    async getLodgeLocationSummary(erID) {
        return await BaseAPI.get(`${resource}/${erID}/Lodges/LocationSummary`);
    },
    async getReferenceDates(erID) {
        return await BaseAPI.get(`${resource}/${erID}/ReferenceDates`)
    },
    async getMealsLocationSummary(erID) {
        return await BaseAPI.get(`expensereports/${erID}/Meals/LocationSummary`);
    },
    async submitApproval(erID) {
        return await BaseAPI.post(`expensereports/${erID}/approve`);
    },
    async deny(erID) {
        return await BaseAPI.post(`expensereports/${erID}/deny`);
    },
    async pay(erID, payDate) {
        return await BaseAPI.post(`expensereports/${erID}/Paid?PaidDate=${payDate}`);
    },
    async setPendingPaymentStatus(erID, statusTypeId) {
        return await BaseAPI.post(`expensereports/${erID}/status/${statusTypeId}`);
    },
    async getExpenseReportValidation(erID, sectionType) {
        return await BaseAPI.get(`expensereports/${erID}/validation?sectionTypeId=${sectionType}`);
    },
    async getExpenseReportSubmission(erID) {
        return await BaseAPI.get(`${resource}/${erID}/submission`);
    },
    async getSummaryCosts(erID) {
        return await BaseAPI.get(`${resource}/${erID}/Review`)
    },
    async deleteExpenseReport(erID) {
        return await BaseAPI.delete(`${resource}/${erID}`)
    }
} 